import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import Spinner from "../../components/Reusable/Spinner";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Skeleton from "../../components/Reusable/Skeleton";
const EditRoleComponent = loadable(
  () => import("../../components/Role/EditRole")
);
const EditRole = () => {
  const { id } = useParams();

  const { data, isLoading } = useGetHook({
    queryKey: [`role-${id}`],
    url: `${APIS.GROUP}${id}/`,
    params: {},
  });

  const { data: Permissions, isLoading: isPermissionsLoading } = useGetHook({
    queryKey: [`logesticPermissions`],
    url: `${APIS.PERMISSIONS}`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["roles", `role-${id}`],
    navigateURL: "/roles",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.GROUP}${id}/`;
    let formData = {
      ...values,
      group_name: values?.role,
      name: values?.role,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Edit Role</span>
      </div>
      {isLoading || isPermissionsLoading ? (
        <Skeleton />
      ) : (
        <EditRoleComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          data={data}
          Permissions={Permissions}
        />
      )}
    </>
  );
};

export default EditRole;
